module.exports = __webpack_public_path__ + "img/blue_066.76b22a2e.png";